import React from 'react';
import styles from "../style/BosTransactionOne.module.css";

export default function BosTransactionListTwo({arrayList}) {
    return (
        <div className={styles.container}>
            <div className={styles.subContainer}>
                <div className={styles.headingBox}>Address</div>
                <div className={styles.headingBox}>Agent</div>
                <div className={styles.headingBox}>Office</div>
                <div className={styles.headingBox}>List/Buy</div>
                <div className={styles.headingBox}>Sold Date</div>
                <div className={styles.headingBox}>Sold Price</div>
                <div className={styles.headingBox}>Paid</div>
                <div className={styles.headingBox}>Docs</div>
                <div className={styles.headingBox} style={{borderRight: "1px solid rgb(191, 191, 191)"}}>Title</div>
            </div>
            {
                arrayList?.map((transaction, idx) => {
                    return <div className={styles.subContainerTwo}>
                        <div className={styles.listBox} style={{textAlign: "left", ...((idx === 0) ? {borderTop: "0px"} : {})}}>{transaction?.address}</div>
                        <div className={styles.listBox} style={{...((idx === 0) ? {borderTop: "0px"} : {})}}>{transaction?.agent}</div>
                        <div className={styles.listBox} style={{...((idx === 0) ? {borderTop: "0px"} : {})}}>{transaction?.office}</div>
                        <div className={styles.listBox} style={{...((idx === 0) ? {borderTop: "0px"} : {})}}>{transaction?.type}</div>
                        <div className={styles.listBox} style={{...((idx === 0) ? {borderTop: "0px"} : {})}}>{transaction?.soldDate}</div>
                        <div className={styles.listBox} style={{...((idx === 0) ? {borderTop: "0px"} : {})}}>{transaction?.soldPrice}</div>
                        <div className={styles.listBox} style={{...((idx === 0) ? {borderTop: "0px"} : {})}}>
                            <div className={styles.circleBox} style={{...(transaction?.paid === "red") && {backgroundColor: "#ff4e4e"}, ...(transaction?.paid === "grey") && {backgroundColor: "grey"}}}></div>
                        </div>
                        <div className={styles.listBox} style={{...((idx === 0) ? {borderTop: "0px"} : {})}}>
                            <div className={styles.circleBox} style={{...(transaction?.docs === "red") && {backgroundColor: "#ff4e4e"}, ...(transaction?.docs === "grey") && {backgroundColor: "grey"}}}></div>
                        </div>
                        <div className={styles.listBox} style={{...((idx === 0) ? {borderTop: "0px"} : {}), borderRight: "1px solid rgb(191, 191, 191)"}}>
                            <div className={styles.circleBox} style={{...(transaction?.title === "red") && {backgroundColor: "#ff4e4e"}, ...(transaction?.title === "grey") && {backgroundColor: "grey"}}}></div>
                        </div>
                    </div>
                })
            }
        </div>
    )
}
